"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var DropArrowUp = function DropArrowUp(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 16 9'
  }, props), /*#__PURE__*/_react["default"].createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(-569.000000, -171.000000)',
    fillRule: 'nonzero',
    fill: 'currentColor'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(577.000000, 175.500000) rotate(-180.000000) translate(-577.000000, -175.500000) translate(569.000000, 171.000000)'
  }, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M15.7675214,0.218803419 C15.5487179,1.54737334e-15 15.1931624,1.54737334e-15 14.974359,0.218803419 L8,7.20683761 L1.01196581,0.218803419 C0.793162393,1.54737334e-15 0.437606838,1.54737334e-15 0.218803419,0.218803419 C-2.28983499e-16,0.437606838 -2.28983499e-16,0.793162393 0.218803419,1.01196581 L7.58974359,8.38290598 C7.6991453,8.49230769 7.83589744,8.54700855 7.98632479,8.54700855 C8.12307692,8.54700855 8.27350427,8.49230769 8.38290598,8.38290598 L15.7538462,1.01196581 C15.9863248,0.793162393 15.9863248,0.437606838 15.7675214,0.218803419 Z'
  })))));
};
/* eslint-enable */
var _default = DropArrowUp;
exports["default"] = _default;